import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';

export interface BrandKit {
  id: string;
  org_id: string;
  logo_url: string | null;
  primary_color: string;
  accent_color: string;
  background_color: string;
  text_color: string;
  heading_font: string;
  body_font: string;
  button_radius_px: number;
  content_width_px: number;
  footer_html: string | null;
  /** Sprint 16a — resolves to {{company.name}} at send time. */
  company_name: string | null;
  company_address: string | null;
  created_at: string;
  updated_at: string;
}

export type BrandKitWritable = Partial<
  Pick<
    BrandKit,
    | 'logo_url'
    | 'primary_color'
    | 'accent_color'
    | 'background_color'
    | 'text_color'
    | 'heading_font'
    | 'body_font'
    | 'button_radius_px'
    | 'content_width_px'
    | 'footer_html'
    | 'company_name'
    | 'company_address'
  >
>;

export function useBrandKit() {
  return useQuery<{ data: BrandKit }>({
    queryKey: ['brand-kit'],
    queryFn: async () => {
      const { data } = await apiClient.get<{ data: BrandKit }>('/brand-kit');
      return data;
    },
  });
}

export function useUpdateBrandKit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: BrandKitWritable) => {
      const { data } = await apiClient.put<{ data: BrandKit }>('/brand-kit', payload);
      return data.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['brand-kit'] }),
  });
}
